import React from 'react'
import MechanisItem from './item.js'
import styles from './index.module.scss'

function MechanisList ({list, current}) {
    const getCurrent = (index) => {
        current(index)
    }
    return (
        <ul className={`mechanisList lx-flex-row-between ${styles.mechanisList}`}>
            <MechanisItem list={list} current={getCurrent}></MechanisItem>
        </ul>
    )
}

export default MechanisList;